/**
 * Adds a carnet to a folder by calling the backend endpoint.
 * @param {string} folderId - The folder ID.
 * @param {string} token - The user's auth token.
 * @param {string} prefix - The API base URL.
 * @param {Array<string>} partnersId - Array of organization IDs for partners with access.
 * @returns {Promise<Object>} - The response from the backend.
 */
export const addCarnet = async (folderId, token, prefix, partnersId = []) => {
  const url = `${prefix}folders/${folderId}/carnet`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        partners_id: partnersId,
      }),
    });
    return await response.json();
  } catch (error) {
    return { success: false, error: error.message };
  }
};